module.exports = __webpack_public_path__ + "img/tcndxq_img1_gray-6.34ab93aa.png";